import React, { useEffect, useRef, useState } from "react";
import Header from "../components/Header";
import { dashboard } from "../handler/LoginAndSingupHandler";

const ContactPage: React.FC = () => {
  const [statistics, setStatistics] = useState({
    students: 0,
    courses: 0,
    teachers: 0,
    awards: 0,
  });

  const runOnce = useRef(false);

  useEffect(() => {
    if (runOnce.current) return;

    runOnce.current = true;

    const loadDashboard = async () => {
      try {
        const response = await dashboard();

        if (response?.statusCode === 200) {
          setStatistics(response.data.dashboard.statistics);
        }
      } catch (error) {
        console.error("Dashboard API error:", error);
      }
    };

    loadDashboard();
  }, []);

  return (
    <>
      <style>
        {`
          /* =========================================================
             GLOBAL
          ========================================================= */

          html {
            scroll-behavior: smooth;
          }

          body {
            margin: 0;
            padding: 0;
            background: #030508;
          }

          .gv-about-page {
            width: 100%;
            min-height: 100vh;
            background:
              radial-gradient(
                circle at 10% 10%,
                rgba(0, 217, 255, 0.07),
                transparent 28%
              ),
              radial-gradient(
                circle at 90% 40%,
                rgba(139, 92, 246, 0.08),
                transparent 30%
              ),
              #030508;

            color: #ffffff;

            overflow-x: hidden;
          }

          .gv-about-page *,
          .gv-about-page *::before,
          .gv-about-page *::after {
            box-sizing: border-box;
          }

          .gv-container {
            width: 100%;
            max-width: 1200px;
            margin: 0 auto;
            padding-left: 24px;
            padding-right: 24px;
          }


          /* =========================================================
             HERO
          ========================================================= */

          .gv-about-hero {
            position: relative;
            padding: 90px 0 100px;
            overflow: hidden;
          }

          .gv-hero-grid {
            position: absolute;
            inset: 0;

            background-image:
              linear-gradient(
                rgba(255,255,255,0.025) 1px,
                transparent 1px
              ),
              linear-gradient(
                90deg,
                rgba(255,255,255,0.025) 1px,
                transparent 1px
              );

            background-size: 40px 40px;

            mask-image: linear-gradient(
              to bottom,
              black,
              transparent
            );

            pointer-events: none;
          }

          .gv-hero-glow {
            position: absolute;

            width: 420px;
            height: 420px;

            border-radius: 50%;

            background: rgba(0, 217, 255, 0.10);

            filter: blur(100px);

            top: -200px;
            left: -150px;

            pointer-events: none;
          }

          .gv-hero-glow-two {
            position: absolute;

            width: 400px;
            height: 400px;

            border-radius: 50%;

            background: rgba(139, 92, 246, 0.10);

            filter: blur(100px);

            right: -150px;
            bottom: -200px;

            pointer-events: none;
          }

          .gv-hero-content {
            position: relative;
            z-index: 2;

            max-width: 850px;
            margin: 0 auto;

            text-align: center;
          }

          .gv-small-label {
            display: inline-flex;
            align-items: center;
            gap: 9px;

            padding: 9px 16px;

            border: 1px solid rgba(0, 217, 255, 0.30);

            border-radius: 8px;

            background: rgba(0, 217, 255, 0.04);

            color: #00d9ff;

            font-size: 11px;
            font-weight: 700;

            letter-spacing: 2px;

            margin-bottom: 22px;
          }

          .gv-small-dot {
            width: 7px;
            height: 7px;

            border-radius: 50%;

            background: #00d9ff;

            box-shadow:
              0 0 8px rgba(0,217,255,0.9);
          }

          .gv-hero-title {
            margin: 0;

            font-size: clamp(38px, 6vw, 76px);

            line-height: 1.05;

            font-weight: 800;

            letter-spacing: -2px;

            background: linear-gradient(
              90deg,
              #ffffff 0%,
              #ffffff 45%,
              #00d9ff 75%,
              #8b5cf6 100%
            );

            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
          }

          .gv-hero-description {
            max-width: 720px;

            margin: 26px auto 0;

            color: #aeb8c7;

            font-size: 17px;

            line-height: 1.8;
          }

          .gv-hero-buttons {
            display: flex;

            justify-content: center;

            gap: 14px;

            margin-top: 34px;

            flex-wrap: wrap;
          }

          .gv-primary-button,
          .gv-secondary-button {
            min-height: 48px;

            padding: 0 24px;

            border-radius: 9px;

            font-size: 14px;

            font-weight: 700;

            text-decoration: none;

            display: inline-flex;

            align-items: center;

            justify-content: center;

            transition: all 0.25s ease;

            cursor: pointer;
          }

          .gv-primary-button {
            color: #001116;

            background: #00d9ff;

            border: 1px solid #00d9ff;

            box-shadow:
              0 0 25px rgba(0,217,255,0.18);
          }

          .gv-primary-button:hover {
            transform: translateY(-2px);

            box-shadow:
              0 0 35px rgba(0,217,255,0.30);
          }

          .gv-secondary-button {
            color: #ffffff;

            background: rgba(255,255,255,0.03);

            border: 1px solid rgba(255,255,255,0.14);
          }

          .gv-secondary-button:hover {
            border-color: rgba(0,217,255,0.45);

            color: #00d9ff;
          }


          /* =========================================================
             STATS
          ========================================================= */

          .gv-stats {
            position: relative;

            z-index: 3;

            margin-top: -30px;

            padding-bottom: 80px;
          }

          .gv-stats-grid {
            display: grid;

            grid-template-columns:
              repeat(4, 1fr);

            gap: 16px;
          }

          .gv-stat-card {
            position: relative;

            padding: 28px 20px;

            border-radius: 14px;

            border: 1px solid rgba(255,255,255,0.08);

            background:
              linear-gradient(
                145deg,
                rgba(255,255,255,0.055),
                rgba(255,255,255,0.015)
              );

            text-align: center;

            overflow: hidden;
          }

          .gv-stat-card::before {
            content: "";

            position: absolute;

            left: 20%;
            right: 20%;
            top: 0;

            height: 1px;

            background: linear-gradient(
              90deg,
              transparent,
              #00d9ff,
              transparent
            );
          }

          .gv-stat-number {
            font-size: 32px;

            font-weight: 800;

            color: #ffffff;

            margin-bottom: 7px;
          }

          .gv-stat-number span {
            color: #00d9ff;
          }

          .gv-stat-label {
            color: #7f8b9c;

            font-size: 12px;

            text-transform: uppercase;

            letter-spacing: 1.4px;
          }


          /* =========================================================
             SECTION
          ========================================================= */

          .gv-section {
            padding: 90px 0;

            border-top:
              1px solid rgba(255,255,255,0.05);
          }

          .gv-section-header {
            max-width: 720px;

            margin-bottom: 50px;
          }

          .gv-section-tag {
            color: #00d9ff;

            font-size: 11px;

            font-weight: 800;

            letter-spacing: 2px;

            text-transform: uppercase;

            margin-bottom: 14px;
          }

          .gv-section-title {
            margin: 0;

            font-size: clamp(30px, 4vw, 48px);

            line-height: 1.15;

            font-weight: 800;
          }

          .gv-section-description {
            margin: 18px 0 0;

            color: #929eaf;

            font-size: 16px;

            line-height: 1.8;
          }


          /* =========================================================
             STORY
          ========================================================= */

          .gv-story-grid {
            display: grid;

            grid-template-columns:
              1fr 1fr;

            gap: 70px;

            align-items: center;
          }

          .gv-story-text p {
            color: #9ba7b8;

            font-size: 16px;

            line-height: 1.9;

            margin: 0 0 20px;
          }

          .gv-story-highlight {
            padding: 22px;

            border-left:
              3px solid #00d9ff;

            border-radius: 0 10px 10px 0;

            background:
              linear-gradient(
                90deg,
                rgba(0,217,255,0.07),
                transparent
              );

            color: #dce5ef;

            line-height: 1.7;
          }

          .gv-story-visual {
            position: relative;

            min-height: 400px;

            border:
              1px solid rgba(255,255,255,0.08);

            border-radius: 20px;

            background:
              radial-gradient(
                circle at 30% 30%,
                rgba(0,217,255,0.12),
                transparent 35%
              ),
              radial-gradient(
                circle at 70% 70%,
                rgba(139,92,246,0.12),
                transparent 35%
              ),
              #070b12;

            display: flex;

            align-items: center;

            justify-content: center;

            overflow: hidden;
          }

          .gv-visual-circle {
            width: 210px;
            height: 210px;

            border-radius: 50%;

            border:
              1px solid rgba(0,217,255,0.35);

            display: flex;

            align-items: center;

            justify-content: center;

            position: relative;

            box-shadow:
              0 0 70px rgba(0,217,255,0.08);
          }

          .gv-visual-circle::before {
            content: "";

            position: absolute;

            width: 150px;
            height: 150px;

            border-radius: 50%;

            border:
              1px dashed rgba(139,92,246,0.5);
          }

          .gv-visual-text {
            position: relative;

            text-align: center;
          }

          .gv-visual-text strong {
            display: block;

            font-size: 30px;

            color: #ffffff;
          }

          .gv-visual-text span {
            color: #00d9ff;

            font-size: 11px;

            letter-spacing: 2px;

            font-weight: 700;
          }


          /* =========================================================
             VALUES
          ========================================================= */

          .gv-values-grid {
            display: grid;

            grid-template-columns:
              repeat(3, 1fr);

            gap: 20px;
          }

          .gv-value-card {
            padding: 30px;

            min-height: 230px;

            border-radius: 16px;

            background:
              linear-gradient(
                145deg,
                rgba(255,255,255,0.055),
                rgba(255,255,255,0.015)
              );

            border:
              1px solid rgba(255,255,255,0.08);

            transition:
              transform 0.25s ease,
              border-color 0.25s ease;
          }

          .gv-value-card:hover {
            transform: translateY(-5px);

            border-color:
              rgba(0,217,255,0.35);
          }

          .gv-value-icon {
            width: 46px;
            height: 46px;

            display: flex;

            align-items: center;

            justify-content: center;

            border-radius: 10px;

            background:
              rgba(0,217,255,0.08);

            border:
              1px solid rgba(0,217,255,0.2);

            color: #00d9ff;

            font-size: 20px;

            margin-bottom: 20px;
          }

          .gv-value-card h3 {
            margin: 0 0 12px;

            font-size: 20px;
          }

          .gv-value-card p {
            margin: 0;

            color: #8e9aaa;

            line-height: 1.7;

            font-size: 14px;
          }


          /* =========================================================
             JOURNEY
          ========================================================= */

          .gv-journey {
            display: grid;

            grid-template-columns:
              repeat(4, 1fr);

            gap: 18px;
          }

          .gv-journey-card {
            position: relative;

            padding: 26px;

            border:
              1px solid rgba(255,255,255,0.08);

            border-radius: 14px;

            background: #070a10;
          }

          .gv-journey-number {
            color: #00d9ff;

            font-size: 12px;

            font-weight: 800;

            letter-spacing: 2px;

            margin-bottom: 15px;
          }

          .gv-journey-card h3 {
            margin: 0 0 10px;

            font-size: 18px;
          }

          .gv-journey-card p {
            margin: 0;

            color: #8b96a6;

            font-size: 14px;

            line-height: 1.7;
          }


          /* =========================================================
             CTA
          ========================================================= */

          .gv-cta {
            padding: 100px 0;
          }

          .gv-cta-box {
            position: relative;

            overflow: hidden;

            text-align: center;

            padding: 65px 30px;

            border-radius: 22px;

            border:
              1px solid rgba(0,217,255,0.18);

            background:
              radial-gradient(
                circle at 50% 0%,
                rgba(0,217,255,0.12),
                transparent 45%
              ),
              #070b12;
          }

          .gv-cta-box h2 {
            margin: 0;

            font-size: clamp(30px, 4vw, 46px);
          }

          .gv-cta-box p {
            max-width: 650px;

            margin: 18px auto 28px;

            color: #8f9aaa;

            line-height: 1.8;
          }


          /* =========================================================
             TABLET
          ========================================================= */

          @media (max-width: 900px) {

            .gv-story-grid {
              grid-template-columns: 1fr;

              gap: 40px;
            }

            .gv-story-visual {
              min-height: 330px;
            }

            .gv-stats-grid {
              grid-template-columns:
                repeat(2, 1fr);
            }

            .gv-values-grid {
              grid-template-columns:
                repeat(2, 1fr);
            }

            .gv-journey {
              grid-template-columns:
                repeat(2, 1fr);
            }
          }


          /* =========================================================
             MOBILE
          ========================================================= */

          @media (max-width: 600px) {

            .gv-container {
              padding-left: 16px;
              padding-right: 16px;
            }

            .gv-about-hero {
              padding:
                55px 0 70px;
            }

            .gv-hero-title {
              font-size: 40px;

              letter-spacing: -1px;
            }

            .gv-hero-description {
              font-size: 14px;

              line-height: 1.7;
            }

            .gv-hero-buttons {
              flex-direction: column;

              width: 100%;
            }

            .gv-primary-button,
            .gv-secondary-button {
              width: 100%;
            }

            .gv-stats {
              margin-top: 0;

              padding-bottom: 30px;
            }

            .gv-stats-grid {
              grid-template-columns:
                repeat(2, 1fr);

              gap: 10px;
            }

            .gv-stat-card {
              padding:
                22px 10px;
            }

            .gv-stat-number {
              font-size: 25px;
            }

            .gv-stat-label {
              font-size: 9px;

              letter-spacing: 1px;
            }

            .gv-section {
              padding: 65px 0;
            }

            .gv-section-header {
              margin-bottom: 32px;
            }

            .gv-section-title {
              font-size: 30px;
            }

            .gv-section-description {
              font-size: 14px;
            }

            .gv-story-grid {
              grid-template-columns: 1fr;

              gap: 30px;
            }

            .gv-story-text p {
              font-size: 14px;

              line-height: 1.8;
            }

            .gv-story-visual {
              min-height: 280px;

              border-radius: 15px;
            }

            .gv-visual-circle {
              width: 170px;
              height: 170px;
            }

            .gv-visual-circle::before {
              width: 125px;
              height: 125px;
            }

            .gv-visual-text strong {
              font-size: 25px;
            }

            .gv-values-grid {
              grid-template-columns: 1fr;

              gap: 14px;
            }

            .gv-value-card {
              min-height: auto;

              padding: 24px;
            }

            .gv-journey {
              grid-template-columns: 1fr;

              gap: 12px;
            }

            .gv-journey-card {
              padding: 22px;
            }

            .gv-cta {
              padding: 65px 0;
            }

            .gv-cta-box {
              padding:
                45px 20px;

              border-radius: 16px;
            }

            .gv-cta-box h2 {
              font-size: 30px;
            }

            .gv-cta-box p {
              font-size: 14px;
            }
          }


          /* =========================================================
             VERY SMALL MOBILE
          ========================================================= */

          @media (max-width: 380px) {

            .gv-hero-title {
              font-size: 34px;
            }

            .gv-stats-grid {
              grid-template-columns: 1fr;
            }

            .gv-stat-card {
              padding: 18px;
            }
          }
        `}
      </style>

      <div className="gv-about-page">

        {/* =======================================================
            HEADER
        ======================================================= */}

        <Header />


        {/* =======================================================
            HERO
        ======================================================= */}

        <section className="gv-about-hero">

          <div className="gv-hero-grid" />

          <div className="gv-hero-glow" />

          <div className="gv-hero-glow-two" />

          <div className="gv-container">

            <div className="gv-hero-content">

              <div className="gv-small-label">
                <span className="gv-small-dot" />
                ABOUT GROWNIVERSE
              </div>

              <h1 className="gv-hero-title">
                Learn. Grow. Succeed.
              </h1>

              <p className="gv-hero-description">
                Growniverse is a learning ecosystem built to help people
                develop practical skills, discover their potential, and
                move confidently toward their personal and professional
                goals.
              </p>

              <div className="gv-hero-buttons">

                <a
                  href="/courses"
                  className="gv-primary-button"
                >
                  Explore Courses
                </a>

                <a
                  href="#our-story"
                  className="gv-secondary-button"
                >
                  Discover Our Story
                </a>

              </div>

            </div>

          </div>

        </section>


        {/* =======================================================
            STATISTICS
        ======================================================= */}

        <section className="gv-stats">

          <div className="gv-container">

            <div className="gv-stats-grid">

              <div className="gv-stat-card">
                <div className="gv-stat-number">
                  {(statistics.students + 1000).toLocaleString()}
                  <span>+</span>
                </div>

                <div className="gv-stat-label">
                  Learners
                </div>
              </div>


              <div className="gv-stat-card">
                <div className="gv-stat-number">
                  {statistics.courses}
                  <span>+</span>
                </div>

                <div className="gv-stat-label">
                  Courses
                </div>
              </div>


              <div className="gv-stat-card">
                <div className="gv-stat-number">
                  {statistics.teachers}
                  <span>+</span>
                </div>

                <div className="gv-stat-label">
                  Mentors
                </div>
              </div>


              <div className="gv-stat-card">
                <div className="gv-stat-number">
                  {statistics.awards}
                  <span>+</span>
                </div>

                <div className="gv-stat-label">
                  Achievements
                </div>
              </div>

            </div>

          </div>

        </section>


        {/* =======================================================
            OUR STORY
        ======================================================= */}

        <section
          id="our-story"
          className="gv-section"
        >

          <div className="gv-container">

            <div className="gv-story-grid">

              <div className="gv-story-text">

                <div className="gv-section-tag">
                  OUR STORY
                </div>

                <h2 className="gv-section-title">
                  Education should create possibilities.
                </h2>

                <p>
                  Growniverse was created with a simple idea: learning
                  should not stop at watching a course or completing a
                  lesson. Real growth happens when knowledge becomes
                  confidence, skills, and action.
                </p>

                <p>
                  Our platform brings together structured courses,
                  practical learning experiences, career-focused
                  development, and opportunities that help learners
                  continue moving forward.
                </p>

                <div className="gv-story-highlight">
                  We believe every learner has the ability to grow.
                  Growniverse exists to provide the environment,
                  knowledge, and direction that can help make that
                  growth possible.
                </div>

              </div>


              <div className="gv-story-visual">

                <div className="gv-visual-circle">

                  <div className="gv-visual-text">

                    <strong>G</strong>

                    <span>
                      GROWIVERSE
                    </span>

                  </div>

                </div>

              </div>

            </div>

          </div>

        </section>


        {/* =======================================================
            WHAT WE BELIEVE
        ======================================================= */}

        <section className="gv-section">

          <div className="gv-container">

            <div className="gv-section-header">

              <div className="gv-section-tag">
                WHAT WE BELIEVE
              </div>

              <h2 className="gv-section-title">
                Growth starts with the right foundation.
              </h2>

              <p className="gv-section-description">
                Everything we build is centered around making learning
                practical, accessible, engaging, and useful in the real
                world.
              </p>

            </div>


            <div className="gv-values-grid">

              <div className="gv-value-card">

                <div className="gv-value-icon">
                  ✦
                </div>

                <h3>
                  Practical Learning
                </h3>

                <p>
                  Learn concepts through structured content and
                  practical knowledge that can be applied beyond the
                  classroom.
                </p>

              </div>


              <div className="gv-value-card">

                <div className="gv-value-icon">
                  ◈
                </div>

                <h3>
                  Continuous Growth
                </h3>

                <p>
                  Growth is a journey. We encourage learners to keep
                  building knowledge, confidence, and new capabilities.
                </p>

              </div>


              <div className="gv-value-card">

                <div className="gv-value-icon">
                  ◎
                </div>

                <h3>
                  Real Opportunities
                </h3>

                <p>
                  Our goal is to connect learning with meaningful
                  opportunities for personal and professional development.
                </p>

              </div>

            </div>

          </div>

        </section>


        {/* =======================================================
            LEARNING JOURNEY
        ======================================================= */}

        <section className="gv-section">

          <div className="gv-container">

            <div className="gv-section-header">

              <div className="gv-section-tag">
                YOUR JOURNEY
              </div>

              <h2 className="gv-section-title">
                From curiosity to capability.
              </h2>

              <p className="gv-section-description">
                Growniverse is designed around the complete learning
                journey.
              </p>

            </div>


            <div className="gv-journey">

              <div className="gv-journey-card">

                <div className="gv-journey-number">
                  01 / DISCOVER
                </div>

                <h3>
                  Find Your Direction
                </h3>

                <p>
                  Explore subjects and learning paths that match your
                  interests and goals.
                </p>

              </div>


              <div className="gv-journey-card">

                <div className="gv-journey-number">
                  02 / LEARN
                </div>

                <h3>
                  Build Knowledge
                </h3>

                <p>
                  Follow structured learning experiences and develop a
                  stronger understanding of your chosen subject.
                </p>

              </div>


              <div className="gv-journey-card">

                <div className="gv-journey-number">
                  03 / PRACTICE
                </div>

                <h3>
                  Develop Skills
                </h3>

                <p>
                  Turn knowledge into useful skills through practice,
                  application, and continued learning.
                </p>

              </div>


              <div className="gv-journey-card">

                <div className="gv-journey-number">
                  04 / GROW
                </div>

                <h3>
                  Move Forward
                </h3>

                <p>
                  Use your growing skills and confidence to pursue new
                  academic, professional, and personal opportunities.
                </p>

              </div>

            </div>

          </div>

        </section>


        {/* =======================================================
            CTA
        ======================================================= */}

        <section className="gv-cta">

          <div className="gv-container">

            <div className="gv-cta-box">

              <div className="gv-section-tag">
                YOUR NEXT STEP
              </div>

              <h2>
                Your growth story starts here.
              </h2>

              <p>
                Explore Growniverse, discover something new, and take
                the next step toward becoming the person you want to be.
              </p>

              <a
                href="/courses"
                className="gv-primary-button"
              >
                Start Learning
              </a>

            </div>

          </div>

        </section>

      </div>
    </>
  );
};

export default ContactPage;